import {QUESTION_TYPE} from 'types/Enum';
import { Question } from './CeoSurvey.props';

export const questions: Question[] = [
  {
    key: 'q1',
    question: 'In what industry does your organization operate (Industry Name or NAICS Code)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q2',
    question: 'What is your current annual revenue (enter $$ number)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q3',
    question: 'What is your current gross margin (enter % margin)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q4',
    question:
      'What is your current net income (EBITDA or EBIDA) margin (enter % margin)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q5',
    question:
      'What is your desired or benchmark net income (EBITDA or EBIDA) margin (enter % margin)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q6',
    question:
      'By what percent has your company or organization grown in the past 12 months (enter % growth)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q7',
    question:
      'By what percent has your industry grown in the past 12 months (enter % industry growth, if known)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q8',
    question:
      'When companies are bought and sold in your industry, is the value of the business determined by a factor (or multiple) of Revenue or a factor (multiple) of Net Income?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  {
    key: 'q9',
    question:
      'Based on your knowledge of the industry, what would you estimate the factor or multiple to be (Example: 2x Revenue, 5x Net Income, etc.)?',
    type: QUESTION_TYPE.Input,
    value: '',
  },
  // {
  //   key: 'q10',
  //   question:
  //     'Do you have any single clients/customers that account for more than 15% of your overall annual revenue?',
  //   type: 'BOOLEAN',
  //   value: '',
  // },
  // {
  //   key: 'q11',
  //   question: 'How many days of operating cash do you currently have on hand?',
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  // {
  //   key: 'q12',
  //   question:
  //     'Based on your answers to the above, what would you estimate the value of your business to be?',
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  // {
  //   key: 'q13',
  //   question:
  //     'Approximately what percent of your annual revenues are recurring or under contracts of 2 years or more?',
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  // {
  //   key: 'q14',
  //   question:
  //     'Are your financials prepared regularly by an accountant or skilled bookkeeper with historical, current, and future projected revenue and expenses?',
  //   type: 'BOOLEAN',
  //   value: '',
  // },
  // {
  //   key: 'q15',
  //   question: `How would you rate your organization's budgeting, financial planning, and reporting processes?`,
  //   type: 'POINTS',
  //   value: '',
  // },
  // {
  //   key: 'q16',
  //   question:
  //     'How often does senior leadership review the overall financial health of your organization and discuss how to grow and improve it?',
  //   type: 'POINTS',
  //   value: '',
  // },
  // {
  //   key: 'q17',
  //   question:
  //     'What do you perceive as the single greatest issue facing your organization currently?',
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  // {
  //   key: 'q18',
  //   question: `What is the biggest impediments to your organization's growth?`,
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  // {
  //   key: 'q19',
  //   question:
  //     'What do customers say about your organization?  What do you hope they would say?',
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  // {
  //   key: 'q20',
  //   question: 'What do they actually say?',
  //   type: QUESTION_TYPE.INPUT,
  //   value: '',
  // },
  {
    key: 'q21',
    question:
      'If you were to put together a crystal clear strategic growth plan, that gets your organization, your leadership, and you ability to innovate and execute all aligned, by what percent (%) do you think it would impact your ability to grow? (enter a number up to one decimal place)',
    type: QUESTION_TYPE.Input,
    value: '',
  },
];
